<template>
  <v-container fluid>
    <!-- Header -->
    <v-row dense class="d-flex mb-0 pb-0" style="height: 48px">
      <!-- View Title -->
      <v-col class="d-flex mt-0 mb-0 pb-0" md="auto">
        <ViewTitle :title="getTitle()" />
      </v-col>
      <!-- /View Title -->
      <v-spacer></v-spacer>
      <v-col class="d-flex justify-end mb-0 pb-0 component" md="auto">
        <SearchTextTable @input="setSearchText" />
      </v-col>
      <v-col class="d-flex justify-end mb-0 pb-0" md="auto">
        <ExplorerHeaderDatesRangeFilter @input="setFilterDates" />
      </v-col>
      <v-col
        class="d-flex justify-end mb-0 pb-0"
        md="auto"
      >
      <v-menu
        close-on-content-click
        dense
        offset-y
      >
        <template v-slot:activator="{ on, attrs }">
          <!-- TODO: Create SelectMenu component -->
        <v-btn
          v-bind="attrs"
          v-on="on"
          class="qmkey-btn-process-filter"
          :class="active ? 'qmkey-btn-process-filter-active' : ''"
        >
          <v-row
            no-gutters
            align="center"
            justify="start"
            class="mr-0 pr-0"
            style="height: 36px"
          >
            <v-col
              cols="auto"
              class="mr-4 text-left"
              tile
              outlined
              style="min-width: 180px"
            >
              {{ current_process_name }}
            </v-col>
            <v-col
              cols="auto"
              tile
              class="mr-0 border-right"
              style="height: 36px"
            >
              <!--
                   Trick: If you specify a height on a column, then it won't
                   vertically align. So we create an empty one with right border
              -->
            </v-col>
            <v-col
              cols="auto"
              class="ma-0"
              tile
              outlined
            >
              <v-icon right class="icon-large">mdi-chevron-down</v-icon>
            </v-col>
          </v-row>
        </v-btn>
      </template>
      <!-- TODO: order process by parent -->
      <v-list
        dense
        small
        flat
        class="overflow-y-auto qmkey-proceso-menu-contents">
        <v-list-item
          small
          v-for="proc in filteredProcesses"
          :key="proc.id"
          @click.prevent="setProcess(proc.id)"
          :input-value="processID === proc.id"
          active-class="qmkey-proceso-menu-item-active"
          :disabled="processID === proc.id"
          class="qmkey-proceso-menu-item"
        >
          <ProcessMenuItem :process="proc" />
        </v-list-item>
      </v-list>
      </v-menu>
    </v-col>
      <v-col class="text-right mb-0 pb-0" md="auto">
        <v-btn-toggle
          active-class="qmkey-explorer-view-active"
          background-color="white"
          borderless
          dense
          tile
        >
          <v-btn
            @click="goToExplorer('ExplorerTable', 1)"
            value="ExplorerTable"
            active-class="qmkey-explorer-view-active"
            icon
            disabled
          >
            <v-icon>mdi-format-list-checkbox</v-icon>
          </v-btn>
          <v-btn
            @click="goToExplorer('ExplorerCalendar', 2)"
            value="ExplorerCalendar"
            icon
            disabled
          >
            <v-icon>mdi-calendar</v-icon>
          </v-btn>
          <v-btn
            @click="goToExplorer('ExplorerReport', 3)"
            value="ExplorerReport"
            icon
            disabled
          >
            <v-icon>mdi-chart-bar</v-icon>
          </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>
    <!-- / Header -->
    <v-container fluid class="qmkey-explorer-view">
    <v-data-table
      :headers="unitCommonColumns"
      :items="units"
      item-key="uid"
      show-select
      show-expand
      hide-default-footer
      must-sort
      :loading="local_loading"
      :search="search"
      :server-items-length="unitsCount"
      :items-per-page="unitsItemsPerPage"
      :page.sync="unitsPage"
      :sortBy="unitsSortBy"
      :sortDesc="unitsSortDesc"
      :selected="table_selected"
      :value="table_selected"
      @page-count="unitsPageCount = $event"
      v-on:update:sort-by="
        unitsSortBy = $event
        if (unitsSortBy) updateQUnitsPagination()
      "
      v-on:update:sort-desc="
        unitsSortDesc = $event
        if (unitsSortBy) updateQUnitsPagination()
      "
      dense
      item-class="qmkey-item-row"
      :loading-text="getNoDataMessage()"
      class="qmkey-explorer-table table-contrast-expand-icon mt-0"
      :header-props="{'sort-icon': sort_icon}"
    >
    <template v-slot:[`item.current_public_version`]="{ item }"> 
        <v-icon
          small
          class="mr-2"
          :color="files[item.current_public_version.mimetype].color"
          @click="handleEvidence(item.current_public_version)"
          v-if="item.current_public_version.mimetype"
        >
          {{ files[item.current_public_version.mimetype].icon }}
        </v-icon>
      </template>
      <template v-slot:[`item.current_workflow_responsible`]="{ item }">
        <span v-if="item.current_workflow_responsible">
          {{ item.current_workflow_responsible }}
        </span>
      </template>
      <template v-slot:[`item.current_workflow_limit`]="{ item }">
        <span
          v-if="item.current_workflow_limit"
          v-bind:class="[
            new Date() >= new Date(item.current_workflow_limit)
              ? 'date-plan-late'
              : 'date-plan-early',
          ]"
        >
          {{
            new Date(item.current_workflow_limit).toLocaleDateString(
              (options = { dateStyle: 'short' }),
            )
          }}
        </span>
      </template>
       <template v-slot:[`item.current_workflow_state`]="{ item }">
        <v-badge
          inline
          left
          :color="item.state_color"
          dot
        >
          {{ item.current_workflow_state}}
        </v-badge>
      </template>
      <!-- Actions -->
      <template v-slot:[`item.action`]="{ item }">
        <!-- Transitions -->
        <v-menu
          open-on-hover
          bottom
          left
          offset-x
          content-class="qmkey-explorer-table-menu-contents"
        >
          <template v-slot:activator="{ on }">
            <v-icon small class="mr-2" v-on="on">mdi-pencil</v-icon>
          </template>
          <v-list dense>
            <v-list-item
              v-for="transition in item['transition_candidates']"
              :key="transition.id"
              @click.stop="performTransition(item, transition)"
            >
              <v-list-item-title>{{ transition.label }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <!--
        TODO:FIXME: Download file only for bps documents. 
        -->   
        <v-btn
          small
          icon
          @click="handleEvidence(item.current_state_document)"
          v-if="item.current_state_document.value"
          :disabled="!item.current_state_document.value"
        >
          <v-icon
            small
            class="mr-2"
          >
            mdi-download
          </v-icon>
        </v-btn>
        <!-- End documents special-->
        <!-- File reports check else clause -->
        <v-menu 
          open-on-hover 
          bottom 
          left 
          offset-x
          content-class="qmkey-explorer-table-menu-contents"
          v-else
        >
          <template v-slot:activator="{ on }">
            <v-icon small class="mr-2" v-on="on">
              mdi-file-download-outline
            </v-icon>
          </template>

          <v-list dense>
            <v-list-item
              v-for="report in item['reports']"
              :key="report.value"
              @click.stop="printItem(item, report.value)"
            >
              <v-list-item-title>{{ report.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <!-- View PDF reports -->
        <v-menu
          open-on-hover
          bottom
          left
          offset-x
          content-class="qmkey-explorer-table-menu-contents"
        >
          <template v-slot:activator="{ on }">
            <v-icon small class="mr-2" v-on="on">mdi-eye-outline</v-icon>
          </template>
          <v-list dense>
            <v-list-item
              v-for="report in item['visor_pdf_reports']"
              :key="report.value"
              @click.stop="pdfViewerItem(item, report.value)"
            >
              <v-list-item-title>{{ report.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <!-- Contacts -->
        <v-menu
          open-on-hover
          close-on-content-click
          dense
          offset-x
          left
          content-class="qmkey-explorer-table-menu-contents"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" small icon>
              <v-icon small class="mr-2">mdi-at</v-icon>
            </v-btn>
          </template>
          <v-list dense class="overflow-y-auto" two-line>
            <v-list-item
              v-for="contact in item.contacts"
              :key="contact.value"
            >
              <v-list-item-avatar color="primary" :size="32">
                <v-img 
                  v-if="contact.photo"
                  :src="$base + contact.photo">
                </v-img>
                <span
                  v-else
                  color="primary"
                >
                  {{ contact.initials }}
                </span>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title v-text="contact.title"></v-list-item-title>
                <v-list-item-subtitle v-text="contact.role"></v-list-item-subtitle>
              </v-list-item-content>
              
              <v-list-item-action>
                <v-icon
                  small
                  color="primary"
                  @click="copyToClipboard(contact.phone)"
                >
                  mdi-phone
                </v-icon>
              </v-list-item-action>
              <v-list-item-action>
                <v-icon 
                  small
                  color="primary"
                  @click="copyToClipboard(contact.email)"
                >
                  mdi-email
                </v-icon>
              </v-list-item-action>              
            </v-list-item>
          </v-list>        
        </v-menu>
        <!-- Allowed Contents -->
        <v-menu
          open-on-hover
          close-on-content-click
          dense
          offset-x
          left
          content-class="qmkey-explorer-table-menu-contents"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" small icon>
              <v-icon small class="mr-2">mdi-plus</v-icon>
            </v-btn>
          </template>
          <v-list dense class="overflow-y-auto">
            <v-list-item
              v-for="allowed in item.allowed_content_types"
              :key="allowed.reference"
              @click.stop="performTransition(item, allowed)"
            >
              <v-list-item-content>
                <v-list-item-title
                  v-text="allowed.readable_type"
                ></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
      <!-- Expanded -->
      <template v-slot:expanded-item="{ item }">
        <td :colspan="unitCommonColumns.length +1"
          class="qmkey-explorer-table-expansion-td"
        >
          <!-- needed to use row length -->
          <v-container fluid>
            <v-row  class="qmkey-explorer-table-expansion-cont">
              <v-tabs
                v-model="tabs"
                icons-and-text
                align-with-title
                background-color="#cac8c9"
                height = 32
                class="qmkey-explorer-table-expansion-panel"
                active-class="qmkey-explorer-table-expansion-panel-active"
              >
                <v-tabs-slider style="display: none"></v-tabs-slider>
                <!-- 
                  FIXME: BP no inliine-box-data defined. 
                  Retrocompatibility.  DEPRECATED 
                -->
                <v-tab v-for="(tab,i) in item['inline_boxes']" :key="i"
                  class="qmkey-explorer-table-expansion-panel-header">
                  <div class="tab">
                    {{ tab.name }}
                  </div>
                </v-tab>
              </v-tabs>
              <v-tabs-items 
                v-model="tabs"
                class="qmkey-explorer-table-expansion-panel-contents"
              >
                <v-tab-item
                  v-for="(tab, i) in item['inline_boxes']"
                  :key="i" class="qmkey-explorer-table-expansion-panel-content"
                >
                  <!-- QUnit data -->
                  <InlineBoxData 
                    v-if="tab.type=='inline-box-data'"
                    :current_qunit="item"
                    :props="tab.props" 
                  />
                  <!--Related Qunits -->
                  <InlineBoxRelated
                    v-else-if="tab.type=='inline-box-related'"
                    :current_qunit="item"
                    :props="tab.props"
                    @form_submit="childFormSubmit(current_unit)"
                  />
                  <!-- Comunications -->
                    <inline-box-comunications
                    v-else-if="tab.type=='inline-box-comunications'"
                    :current_qunit="item" 
                    :props="tab.props" 
                    />
                  <!-- WORKFLOW -->
                  <inline-box-workflow 
                  v-else-if="tab.type=='inline-box-workflow'"
                  :current_qunit="item"
                  :props="tab.props"  />
                  <!-- Versions -->
                  <inline-box-versions
                    v-else-if="tab.type=='inline-box-documents'"
                    :current_qunit="item"
                    @download_file="handleEvidence"
                    :props="tab.props" 
                  />
                </v-tab-item>                
              </v-tabs-items>
            </v-row>
          </v-container>
        </td>
      </template>
      <!-- Pagination -->      
      <template v-slot:footer>
        <q-pagination
          :max_visible_buttons="3"
          :current_page="unitsPage"
          :total_units="unitsCount"
          :allow_change_items_per_page="false"
          :items_per_page="itemsPerPage"
          :units_length="units.length"
          @page_changed="updateQUnitsPagination"
          @items_per_page_changed="updateItemsPerPage">
        </q-pagination>
      </template>
      <!-- /Pagination -->
    </v-data-table>
    <!-- Modal dialog -->    
    <modal-dialog-form
      :title="modal_title"
      :showModalDialog="showModalDialog"
      :fields_to_collect="fields_to_collect"
      :submit_button_text="submit_button_caption"
      @close-dialog="toggle_dialog"
      @submit="process_form"
    >
    </modal-dialog-form>
    <!-- /Modal dialog -->    
    </v-container>

  </v-container>
</template>


<script>
import QUnit from '@/api/QUnit'
import QReport from '@/api/QReportsItem'
import { mapActions, mapMutations, mapState } from 'vuex'
import ViewTitle from '@/components/ViewTitle'
import ExplorerHeaderAdvancedFilter from './ExplorerHeaderAdvancedFilter'
import ExplorerHeaderDatesRangeFilter from './ExplorerHeaderDatesRangeFilter'
import SearchTextTable from '@/components/SearchTextTable'
import ProcessMenuItem from './ProcessMenuItem'
import InlineBoxRelated from './RelatedInlineBox'
import UserSelectComponent from './UserSelectComponent'
import InlineBoxData from './DataInlineBox'
import InlineBoxVersions from './VersionsInlineBox.vue'
import InlineBoxWorkflow from './WorkflowInlineBox.vue'
import ModalDialogForm from './ModalDialog'
import InlineBoxComunications from './InlineBoxComunications'
import QPagination from '@/components/QPagination'


export default {
  name: 'TodoListTable',
  components: {
    ViewTitle,
    ExplorerHeaderAdvancedFilter,
    SearchTextTable,
    ExplorerHeaderDatesRangeFilter,
    ProcessMenuItem,
    InlineBoxRelated,
    UserSelectComponent,
    InlineBoxData,
    InlineBoxVersions,
    InlineBoxWorkflow,
    ModalDialogForm,
    InlineBoxComunications,
    QPagination
  },
  data() {
    return {
      unitsPage: 1,
      unitsPageCount: 0,
      itemsPerPageArray: [10],
      itemsPerPage: 10,
      unitsSortBy: 'current_workflow_limit',
      unitsSortDesc: false,
      search: '',
      editedItem: {},
      can_create_units: false,
      creation_fields_to_collect: [],
      creation_form_error_message: '',
      fields_to_collect: [],
      show_transitions: true,
      current_transition: {},
      form_error_message: '',
      subPane: 'tree',
      jsdata: '',
      edjsdata: '',
      isTyping: false,
      maximized: {
        fields: false,
        relations: true,
        evidences: false,
        workflow: false,
      },
      selected: [],
      workflowFields: [
        { value: 'transition', text: 'Transition' },
        { value: 'state_in', text: 'Previous State' },
        { value: 'state_out', text: 'Next State' },
        { value: 'transition_time', text: 'Execution Time' },
        { value: 'transition_user', text: 'Executed By' },
        { value: 'destination_responsible', text: 'Responsible' },
        { value: 'destination_limit', text: 'Limit' },
      ],
      relationFields: [
        { value: 'title', text: 'Title', sortable: true },
        { value: 'current_workflow_responsible', text: 'Responsible' },
        { value: 'current_workflow_limit', text: 'Limit' },
        { value: 'current_workflow_state', text: 'State' },
        { value: 'readable_type', text: 'Type', sortable: true },
      ],
      fieldsColumns: [
        { value: 'label', text: 'Campo', sortable: false },
        { value: 'extended_value', text: 'Valor', sortable: false },
      ],
      evidencesColumns: [
        { value: 'title', text: 'Titulo', sortable: false },
        { value: 'type', text: 'Tipo', sortable: false },
        { value: 'creation_date', text: 'F. Creación', sortable: false },
        {
          value: 'modification_date',
          text: 'F. Modificación',
          sortable: false,
        },
        {
          value: 'version',
          text: 'Version',
          sortable: false,
        },
        { value: 'actions', text: 'Actions', sortable: false },
      ],
      addUnitBussinessProcess: '',
      addUnitParentProcess: '',
      business_process_name: '',
      disableAdddModalButtons: false,
      disableTransitionModalButtons: false,
      tabs: null,
      unitCommonColumns: [
        {
          value: 'business_process_name',
          text: 'Type',
          align: 'start',
          sortable: true,
        },
        {
          value: 'reference',
          text: 'Referencia',
          sortable: true,
        },
        {
          value: 'title',
          text: 'Title',
          sortable: true,
        },
        {
          value: 'start',
          text: 'Creation Date',
          sortable: true,
        },
        {
          value: 'current_workflow_state',
          text: 'State',
        },
        {
          value: 'current_workflow_limit',
          text: 'Limit',
          sortable: true,
        },
        {
          value: 'action',
          text: 'Actions',
          sortable: false,
        },
        {
          value: 'data-table-expand',
          text: '',
          sortable: false,
        },
      ],
      current_process_name: 'Procesos',
      active: false,
      // page_number: 1,
      // unitsItemsPerPage: 10,
      // New fields
      showModalDialog: false,
      valid: null,
      loading: false,
      addModalDialog: null,
      modal_title:'',
      submit_button_caption:'',
    }
  },
  computed: {
    ...mapState([
      'sitePath',
      'isLoading',
      'message',
      'sites',
      'user',
      'units',
      'unitsCount',
      'unitsItemsPerPage',
      'current_business_process',
      'current_unit',
      'current_parent_process',
      'searchText',
      'allStandards',
      'filteredProcesses',
      'currentStandardID',
      'processID',
      'context_title',
      'current_business_process_name',
      'current_page_number',
      'table_selected',
    ]),
    // current_page_number() {
    //   return this.unitsPage
    // },
    local_loading() {
      return this.isLoading
    },
    sort_icon() {
      return this.unitsSortDesc ? 'mdi-sort-descending' : 'mdi-sort-ascending'
    },
  },
  mounted: function () {
    // this.SET_BUSINESS_PROCESS(this.$route.query.business_process)
    let pk = this.$route.query.pk ? this.$route.query.pk : ''
    //   this.checkCanCreateUnit(this.current_business_process)
    if (this.$auth.isAuthenticated() && this.$session.exists('user')) {
      // On reload get BP from querystring
      this.EXPLORE_UNITS_TODOLIST({
        site: this.sitePath,
        user_id: this.user.id,
        process_id: this.processID,
        search_text: this.searchText,
        filters_form: this.filtersFormData,
        units_page: this.unitsPage,
        units_sort_by: this.unitsSortBy,
        units_sort_desc: this.unitsSortDesc,
        pk: pk,
      })
        .then((data) => {
          // this.units = data.results
          // this.unitsCount = data['count']
          // this.unitsPage = data['current_page_number']
        })
        .catch((error) => console.log(error))
    }
  },
  updated: function () {
    if (this.jsdata) {
      var jsscript = document.createElement('script')
      jsscript.innerText = this.jsdata
      document.head.appendChild(jsscript)
    }
    this.unitsPage = this.current_page_number
  },
  // Watch current route change to reload BP
  watch: {
    $route(to, _from) {
      this.jsdata = ''
      // this.SET_BUSINESS_PROCESS(to.query.business_process)
      // this.checkCanCreateUnit(this.current_business_process)
      let pk = to.query.pk
      this.EXPLORE_UNITS_TODOLIST({
        site: this.sitePath,
        user_id: this.user.id,
        process_id: this.processID,
        search_text: this.search,
        filters_form: this.filtersFormData,
        units_page: this.unitsPage,
        units_sort_by: this.unitsSortBy,
        units_sort_desc: this.unitsSortDesc,
        pk: pk,
      })
        .then((data) => {
          // this.units = data.results
        })
        .catch((error) => console.log(error))
    },
  },
  methods: {
    addUnit(business_process, parent_qunit_id) {
      this.creation_form_error_message = ''
      parent_qunit_id = parent_qunit_id || ''
      if (!business_process) {
        business_process = this.current_business_process
      }
      if (business_process) {
        QUnit.getFieldsToCollectDuringCreation(
          this.sitePath,
          business_process,
          parent_qunit_id
        )
          .then(data => {
            this.fields_to_collect = data['fields']
            // this.creation_fields_to_collect = data['fields']
            this.jsdata = data['js']
            this.addUnitBussinessProcess = business_process
            this.addUnitParentProcess = parent_qunit_id
            this.business_process_name = data['business_process_name']
            this.addModalDialog = true
            this.showModalDialog = true
            // TODO:Lang
            this.modal_title = 'Add new ' + this.business_process_name
            this.submit_button_caption = 'Add'
          })
          .catch(
            error =>
              (this.creation_form_error_message =
                error.body || error.response.data),
          )
      } else {
        this.creation_form_error_message = 'no business_process provided!'
        // this.$refs.addmodal.show()
      } 
    },
     submitAddUnit(form_data) {
      //  evt.preventDefault()
       //this.SET_BUSINESS_PROCESS(this.$route.query.business_process)
       let current_item_uid = this.current_unit['uid']
      this.$root.$loader.show('Sending...',{})
       QUnit.createUnit(this.sitePath, form_data)
         .then(data => {
          //  this.$refs.addmodal.hide()
           this.selected = [data]
           if (this.addUnitBussinessProcess == this.current_business_process){
             current_item_uid = data.uid
           }
           this.toggle_dialog()
           this.$root.$loader.hide()
           this.EXPLORE_UNITS_TODOLIST({
            site: this.sitePath,
            user_id: this.user.id,
            process_id: this.processID,
            search_text: this.search,
            filters_form: this.filtersFormData,
            units_page: this.unitsPage,
            units_sort_by: this.unitsSortBy,
            units_sort_desc: this.unitsSortDesc
          })
         })
         .catch(error =>{
             (this.creation_form_error_message =
               error.body || error.response.data);
             this.disableAdddModalButtons=false
         })
     },    
    performTransition(unit, transition) {
      this.SET_CURRENT_UNIT(unit)
      this.form_error_message = ''
      if (transition['related_business_process']) {
        this.addUnit(
          transition['related_business_process'],
          this.current_unit['uid'],
        )
      } else {
        QUnit.getFieldsToCollectDuringTransition(
          this.sitePath,
          this.current_unit['uid'],
          transition['id'],
        )
          .then((data) => {
            this.creation_fields_to_collect = []
            this.fields_to_collect = data['fields']
            this.jsdata = data['js']
            this.current_transition = transition
            // this.$refs.transmodal.show()
            this.showModalDialog = true
            this.addModalDialog = false
            // TODO:Lang
            this.modal_title = this.current_transition.label
            this.submit_button_caption = 'Save'
          })
          .catch(
            // TODO: Manage error. If there're an error in transition
            // notifications table and form will be wrong
            (error) => (this.form_error_message = error.body || error.response),
          )
      }
    },
    
    submitTransition(form_data) {
      // evt.preventDefault()
      this.disableTransitionModalButtons = true
      // let current_item_uid = this.current_unit['uid']
      // var new_items = []
      //       this.selected = []
      //       this.SET_TABLE_SELECTED([])
      this.$root.$loader.show('Sending...',{})
      QUnit.executeTransition(
        this.sitePath,
        this.current_unit['uid'],
        form_data,
      )
        .then((data) => {
          this.fields_to_collect = []
          this.form_error_message = ''
          this.show_transitions = false
          this.disableTransitionModalButtons = false
          this.toggle_dialog()
          this.$root.$loader.hide()
          this.EXPLORE_UNITS_TODOLIST({
            site: this.sitePath,
            user_id: this.user.id,
            process_id: this.processID,
            search_text: this.searchText,
            filters_form: this.filtersFormData,
            units_page: this.unitsPage,
            units_sort_by: this.unitsSortBy,
            units_sort_desc: this.unitsSortDesc
          })          
        })
        .catch((error) => {
          this.form_error_message = error.body || error.response.data
          this.disableTransitionModalButtons = false
        })
    },
    updateQUnitsPagination(page) {
      this.unitsPage = page
      if (this.$auth.isAuthenticated() && this.$session.exists('user')) {
        this.EXPLORE_UNITS_TODOLIST({
          site: this.sitePath,
          user_id: this.user.id,
          process_id: this.processID,
          search_text: this.searchText,
          filters_form: this.filtersFormData,
          units_page: this.unitsPage,
          units_sort_by: this.unitsSortBy,
          units_sort_desc: this.unitsSortDesc,
        })
          .catch((error) => console.log(error))
      }
    },
    updateItemsPerPage(items_per_page){
      this.itemsPerPage = items_per_page
    },
    getStateColor(initial, close) {
      if (initial) {
        return 'initial_state'
      } else if (close) {
        return 'final_state_local'
      }
      return 'working_state_local'
    },
    downloadFile(data, filename) {
      // It is necessary to create a new blob object with mime-type explicitly set
      // otherwise only Chrome works like it should
      var newBlob = new Blob([data.data], { type: 'application/vnd' })

      // IE doesn't allow using a blob object directly as link href
      // instead it is necessary to use msSaveOrOpenBlob
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob)
        return
      }

      // For other browsers:
      // Create a link pointing to the ObjectURL containing the blob.
      const ob = window.URL.createObjectURL(newBlob)
      var link = document.createElement('a')
      link.href = ob
      link.download = filename //+ '.docx'
      link.click()
      setTimeout(function () {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(ob)
      }, 100)
    },
    printItem(item, template) {
      QReport.printQUnit(this.sitePath, item.uid, template)
        .then((data) => {
          this.downloadFile(data, item.titulo + '.docx')
        })
        .catch((error) => console.log(error))
    },

    pdfViewerItem(item, template) {
      this.$router.push({
        path: 'pdf',
        query: { uid: item.uid, template: template },
      })
    },

    handleEvidence(row) {
      QUnit.getQUnitFile(this.sitePath, row.qunit_id, row.attribute, row.value)
        .then((data) => {
          this.downloadFile(data, row.title)
        })
        .catch((error) => console.log('handleEvidence', error))
    },
    childFormSubmit(current_unit) {
      // console.log('ExplorerTable.childFormSubmit')
      var new_items = []
      QUnit.getQUnit(this.sitePath, current_unit['uid'])
        .then((data) => {
          for (var i = 0; i < this.units.length; i++) {
            var item = this.units[i]
            if (item.uid == current_unit['uid']) {
              item = data
              this.selected = item
            }
            new_items.push(item)
          }
          this.units = new_items
        })
        .catch((error) => console.log('childFormSubmit', error))
    },
    ...mapActions(['GET_ALL_SITES', 'EXPLORE_UNITS_TODOLIST', 'OPEN_UNIT']),
    ...mapMutations([
      'SET_CURRENT_SITE',
      'SET_USER',
      'SET_MESSAGE',
      'SET_BUSINESS_PROCESS',
      'SET_PARENT_PROCESS',
      'SET_CURRENT_UNIT',
      'SET_CONTEXT_TITLE',
      'SET_TABLE_SELECTED',
      'SET_CURRENT_PROCESS',
      'SET_FILTER_DATES',
      'SET_SEARCH_TEXT',
    ]),

    getNoDataMessage() {
      if (this.message) {
        if (this.message.response) {
          if (this.message.response.data) {
            return this.message.response.data
          }
        } else {
          if (typeof this.message === 'string') {
            return this.message
          }
        }
      }
      return 'No data available'
    },
    getTitle() {
      return 'TODOLIST ' + this.user.first_name + ' ' + this.user.last_name
    },
    setProcess(id) {
      this.SET_CURRENT_PROCESS(id)
      let name = 'Procesos'
      let filtered = false
      if (!this.processID == '') {
        for (var i = 0; i < this.filteredProcesses.length; i++) {
          if (this.filteredProcesses[i].id === this.processID) {
            name = this.filteredProcesses[i].name
            filtered = true
          }
        }
      }
      this.active = filtered
      this.current_process_name = name
      this.EXPLORE_UNITS_TODOLIST({
        site: this.sitePath,
        user_id: this.user.id,
        process_id: id,
        search_text: this.searchText,
        filters_form: this.filtersFormData,
        units_page: 1,
      })
        .catch((error) => console.log(error))
    },
    setSearchText(search_text) {
      this.SET_SEARCH_TEXT(search_text)
      this.EXPLORE_UNITS_TODOLIST({
        site: this.sitePath,
        user_id: this.user.id,
        process_id: this.processID,
        search_text: search_text,
        filters_form: this.filtersFormData,
        units_page: 1,
      })
        .catch((error) => console.log(error))
    },
    setFilterDates(dates_range) {
      this.SET_FILTER_DATES(dates_range)
      this.EXPLORE_UNITS_TODOLIST({
        site: this.sitePath,
        user_id: this.user.id,
        process_id: this.processID,
        search_text: this.searchText,
        filters_form: this.filtersFormData,
        units_page: 1,
        filter_dates: dates_range,
      })
        .catch((error) => console.log(error))
    },
    // NEW methods
    clear: function() {
       this.$refs.transitionForm.clear();
       this.alert = false
     },
     close: function() {
       this.clear()
       this.addUnitBussinessProcess = ''
       this.addUnitParentProcess = ''
       this.fields_to_collect = []
       this.creation_fields_to_collect = []
       this.showModalDialog = false
       this.valid = true
       this.disable = false
     },
     clearAddForm: function() {
       this.$refs.creationform.clear()
       this.alert = false
     },
     closeAddForm: function() {
       this.clearAddForm()
       this.addUnitBussinessProcess = ''
       this.addUnitParentProcess = ''
       this.fields_to_collect = []
       this.creation_fields_to_collect = []
       this.showAddModalDialog = false
       this.valid = true
       this.disable = false
     },
     toggle_dialog() {
      this.addUnitBussinessProcess = ''
      this.addUnitParentProcess = ''
      this.fields_to_collect = []
      this.creation_fields_to_collect = []
      this.showModalDialog = false
      this.addModalDialog = null
      // this.$root.$loader.hide('I completed some action! Yay!', { timeout: 5000, location: 'top' }, () => { console.log( 'Callback after snackbar hidden' ) })
    },
    process_form: function (form_data) {
      
      console.log('Explorer, form submit', form_data)
      form_data.append('business_process', this.addUnitBussinessProcess)
      form_data.append('parent_process', this.addUnitParentProcess)
      if (this.addModalDialog) {
        console.log('Perform add QUnit')
        this.submitAddUnit(form_data)        
      }else{
        console.log('Perform Transition')
        form_data.append('transition_id', this.current_transition.id)
        this.submitTransition(form_data)
      }
      // this.$root.$loader.hide()
    }
  },
}
</script>


<style lang="scss">
@import '@/sass/explorer.scss';
</style>
